const pt = {
  nav: {
    dashboard: 'Dashboard',
    operation: 'Operação',
    subscribers: 'Mensalistas',
    plans: 'Planos',
    login: 'Login',
    getStarted: 'Começar Agora',
  },
  hero: {
    title1: 'Gestão',
    titleHighlight: 'Inteligente',
    title2: 'de Estacionamentos',
    subtitle:
      'Controle pátio, faturamento, mensalistas e regras de preço em tempo real. Uma plataforma moderna, desenhada para alta conversão e uso rápido.',
    getStarted: 'Começar Agora',
    accessSystem: 'Acessar Sistema',
    vehiclesInYard: 'Veículos no Pátio',
    occupancy: 'de Ocupação',
    revenueToday: 'Faturamento Hoje',
    transactions: 'transações avulsas',
    avgTicket: 'Ticket Médio',
    perVehicle: 'Por veículo finalizado',
    cashStatus: 'Status do Caixa',
    open: 'Aberto',
    startedAt: 'iniciou há 4h 30m',
  },
  yard: {
    badge: 'Mapeamento Interativo',
    title: 'Mapa de Vagas em Tempo Real',
    subtitle:
      'Visualize rapidamente a ocupação do seu pátio. Identifique vagas livres, ocupadas, reservadas ou em manutenção com um simples olhar.',
    free: 'Vagas Livres prontas para uso',
    occupied: 'Vagas Ocupadas com a placa do veículo',
    reserved: 'Vagas Reservadas para clientes especiais',
    maintenance: 'Vagas en Manutenção temporariamente bloqueadas',
  },
  op: {
    title: 'Check-out Ultra Rápido',
    subtitle:
      'O processo de saída foi otimizado para que seu operador não perca tempo. Tudo na mesma tela, com gavetas deslizantes e atalhos práticos.',
    checkout: 'Finalizar Saída',
    entryAt: 'Entrada às 08:30',
    duration: 'Permanência',
    amount: 'Valor a cobrar',
    cash: 'Dinheiro',
    pix: 'Pix',
    confirm: 'Confirmar e Finalizar',
  },
  sub: {
    badge: 'Receita Recorrente',
    title: 'Gestão de Mensalistas',
    subtitle:
      'Fidelize seus clientes com planos mensais e controle a inadimplência. O sistema reconhece automaticamente os veículos cadastrados.',
    active: '🟢 Mensalista Ativo',
    plates: 'Placas Cadastradas',
    dueDate: 'Vencimento',
    monthlyFee: 'Mensalidade',
    dueDay: 'Dia 05',
    recognitionTitle: 'Reconhecimento Automático',
    recognitionDesc:
      'Ao digitar a placa, o sistema avisa se é um mensalista e isenta a cobrança avulsa.',
    multiplePlatesTitle: 'Múltiplas Placas',
    multiplePlatesDesc:
      'Cadastre vários veículos para o mesmo mensalista (uso alternado).',
    defaultControlTitle: 'Controle de Inadimplência',
    defaultControlDesc:
      'Alertas visuais para mensalidades atrasadas no momento do check-in e histórico de pagamentos.',
  },
  price: {
    title: 'Motor de Precificação Flexível',
    subtitle:
      'Seja qual for a regra do seu estacionamento, o Parkko calcula para você automaticamente. Sem erros e sem calculadora.',
    f1Title: 'Tarifas Diferenciadas por Veículo',
    f1Desc:
      'Preços diferentes para carros, motos, vans ou caminhões. Configure cada um com flexibilidade.',
    f2Title: 'Horários de Pico',
    f2Desc:
      'Aumente o preço automaticamente em horários de maior movimento com um multiplicador configurável.',
    f3Title: 'Preço Progressivo',
    f3Desc:
      'Configure o valor da primeira hora e frações/horas adicionais de forma exata ou arredondada.',
    f4Title: 'Teto Diário e Tolerância',
    f4Desc:
      'Estabeleça um valor máximo a ser cobrado por dia e defina os minutos de isenção.',
  },
  fin: {
    title: 'Inteligência Financeira',
    subtitle:
      'Tome decisões baseadas em dados reais. Acompanhe a evolução do seu faturamento e compare a estabilidade dos mensalistas com os picos da receita rotativa.',
    f1: 'Gráficos de fácil leitura por período',
    f2: 'Exportação para CSV (Compatível com Contabilidade)',
    f3: 'Fechamento de caixa detalhado e blindado',
    chartTitle: 'Composição de Receita',
    chartDesc: 'Rotativo vs Mensalistas (Últimos 7 dias)',
    rotary: 'Rotativo',
    monthly: 'Mensalista',
    mon: 'Seg',
    tue: 'Ter',
    wed: 'Qua',
    thu: 'Qui',
    fri: 'Sex',
    sat: 'Sab',
    sun: 'Dom',
  },
  pay: {
    title: 'Gestão de Pagamentos Inteligente',
    subtitle:
      'Mantenha a saúde financeira do seu estacionamento sob controle. Tenha visibilidade clara das suas receitas e ofereça flexibilidade na hora de cobrar.',
    predictTitle: 'Previsibilidade de Pagamentos',
    predictDesc:
      'Tenha uma visão clara dos seus recebíveis futuros. O sistema projeta seu faturamento com base em mensalistas ativos e histórico de clientes rotativos, facilitando seu planejamento financeiro.',
    methodsTitle: 'Múltiplos Métodos',
    methodsDesc:
      'Ofereça comodidade aos clientes registrando pagamentos de forma rápida e segura através de diversos métodos integrados:',
    card: 'Cartão (Crédito/Débito)',
    pix: 'PIX',
    cash: 'Dinheiro',
    cashTitle: 'Gestão de Caixa Completa',
    cashDesc:
      'Controle operacional blindado. Gerencie aberturas com fundo de troco, fechamentos detalhados por operador e monitore o fluxo de caixa em tempo real para evitar perdas e furos operacionais.',
  },
  faq: {
    title: 'Planos e Preços',
    subtitle:
      'Escolha o plano ideal para o tamanho da sua operação. Sem taxas ocultas, sem surpresas no fim do mês.',
    popular: 'Mais Popular',
    proTitle: 'Profissional',
    proDesc: 'Ideal para estacionamentos em crescimento',
    month: '/mês',
    proF1: 'Gestão de Mensalistas (Módulo completo)',
    proF2: 'Check-in e Check-out inteligente',
    proF3: 'Painel de KPIs e Inteligência Financeira',
    proF4: 'Mapa de Vagas em tempo real',
    proF5: 'Cadastro de veículos e clientes',
    getStarted: 'Começar Agora',
    entTitle: 'Enterprise',
    entDesc: 'Para operações de grande escala e requisitos complexos',
    custom: 'Sob Consulta',
    entF1: 'Tudo do plano Profissional',
    entF2: 'Impressão de tickets física',
    entF3: 'Suporte prioritário 24/7',
    entF4: 'Integração com hardware de automação',
    entF5: 'Gestão multi-unidades (vários estacionamentos)',
    talkToUs: 'Falar com Consultor',
    faqTitle: 'Perguntas Frequentes',
    q1: 'Funciona em celular?',
    a1: 'Sim! O sistema foi projetado para ser "Mobile First", funcionando perfeitamente em qualquer smartphone ou tablet, ideal para atendentes no pátio.',
    q2: 'Preciso de equipamentos especiais?',
    a2: 'Não. Basta um dispositivo com acesso à internet (celular, tablet ou computador). Nenhuma instalação complexa é necessária.',
    q3: 'Posso configurar meus próprios preços?',
    a3: 'Com certeza. Você pode criar regras personalizadas de valor inicial, hora adicional, teto diário e tolerância para diferentes tipos de veículos.',
    q4: 'Posso ter mais de um estacionamento?',
    a4: 'O plano atende a uma unidade. Para múltiplas unidades, entre em contato para um plano corporativo com desconto.',
    q5: 'Como funciona a segurança dos dados?',
    a5: 'Seus dados ficam salvos em nuvem em servidores ultra seguros. Você não perde nenhuma informação mesmo se o seu computador ou celular quebrar.',
  },
  footer: {
    title: 'Assuma o controle do seu estacionamento.',
    subtitle:
      'Pare de perder dinheiro com controles manuais. A modernização que seu negócio precisa está a um clique de distância.',
    demo: 'Solicitar Demonstração',
    rights: 'Todos os direitos reservados.',
  },
  demo: {
    title: 'Solicite uma Demonstração',
    desc: 'Preencha seus dados abaixo e descubra como o Parkko pode transformar a gestão do seu estacionamento.',
    name: 'Nome Completo',
    company: 'Empresa',
    email: 'Email Corporativo',
    phone: 'Telefone / WhatsApp',
    spots: 'Número de Vagas',
    submit: 'Enviar Solicitação',
    successTitle: 'Solicitação enviada!',
    successDesc:
      'Nossa equipe entrará em contato em breve para a demonstração.',
  },
}

const en = {
  nav: {
    dashboard: 'Dashboard',
    operation: 'Operation',
    subscribers: 'Subscribers',
    plans: 'Plans',
    login: 'Login',
    getStarted: 'Get Started',
  },
  hero: {
    title1: 'Smart Parking',
    titleHighlight: 'Management',
    title2: '',
    subtitle:
      'Control yard, billing, subscribers, and pricing rules in real-time. A modern platform designed for high conversion and fast usage.',
    getStarted: 'Get Started',
    accessSystem: 'Access System',
    vehiclesInYard: 'Vehicles in Yard',
    occupancy: 'Occupancy',
    revenueToday: 'Revenue Today',
    transactions: 'single transactions',
    avgTicket: 'Avg Ticket',
    perVehicle: 'Per completed vehicle',
    cashStatus: 'Cash Status',
    open: 'Open',
    startedAt: 'started 4h 30m ago',
  },
  yard: {
    badge: 'Interactive Mapping',
    title: 'Real-time Space Map',
    subtitle:
      'Quickly visualize your yard occupancy. Identify free, occupied, reserved, or maintenance spaces at a glance.',
    free: 'Free spaces ready for use',
    occupied: 'Occupied spaces with vehicle plate',
    reserved: 'Reserved spaces for special clients',
    maintenance: 'Maintenance spaces temporarily blocked',
  },
  op: {
    title: 'Ultra Fast Check-out',
    subtitle:
      'The checkout process was optimized so your operator wastes no time. Everything on the same screen, with sliding drawers and handy shortcuts.',
    checkout: 'Complete Checkout',
    entryAt: 'Entry at 08:30',
    duration: 'Duration',
    amount: 'Amount to charge',
    cash: 'Cash',
    pix: 'Pix/Transfer',
    confirm: 'Confirm and Finish',
  },
  sub: {
    badge: 'Recurring Revenue',
    title: 'Subscriber Management',
    subtitle:
      'Retain your customers with monthly plans and control defaults. The system automatically recognizes registered vehicles.',
    active: '🟢 Active Subscriber',
    plates: 'Registered Plates',
    dueDate: 'Due Date',
    monthlyFee: 'Monthly Fee',
    dueDay: 'Day 05',
    recognitionTitle: 'Automatic Recognition',
    recognitionDesc:
      'When typing the plate, the system warns if it is a subscriber and exempts the single charge.',
    multiplePlatesTitle: 'Multiple Plates',
    multiplePlatesDesc:
      'Register multiple vehicles for the same subscriber (alternate use).',
    defaultControlTitle: 'Default Control',
    defaultControlDesc:
      'Visual alerts for overdue monthly fees at check-in and payment history.',
  },
  price: {
    title: 'Flexible Pricing Engine',
    subtitle:
      'Whatever the rule of your parking lot, Parkko calculates it for you automatically. No errors and no calculator.',
    f1Title: 'Different Rates per Vehicle',
    f1Desc:
      'Different prices for cars, motorcycles, vans, or trucks. Configure each one flexibly.',
    f2Title: 'Peak Hours',
    f2Desc:
      'Automatically increase the price during peak hours with a configurable multiplier.',
    f3Title: 'Progressive Pricing',
    f3Desc:
      'Set the value of the first hour and additional fractions/hours exactly or rounded.',
    f4Title: 'Daily Cap and Grace Period',
    f4Desc:
      'Establish a maximum amount to be charged per day and define the exemption minutes.',
  },
  fin: {
    title: 'Financial Intelligence',
    subtitle:
      'Make decisions based on real data. Track your revenue evolution and compare subscriber stability with rotary revenue peaks.',
    f1: 'Easy-to-read charts per period',
    f2: 'Export to CSV (Accounting Compatible)',
    f3: 'Detailed and bulletproof cash closing',
    chartTitle: 'Revenue Composition',
    chartDesc: 'Rotary vs Subscribers (Last 7 days)',
    rotary: 'Rotary',
    monthly: 'Subscriber',
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    sun: 'Sun',
  },
  pay: {
    title: 'Smart Payment Management',
    subtitle:
      'Keep your parking lot financial health under control. Have clear visibility of your revenue and offer flexibility when charging.',
    predictTitle: 'Payment Predictability',
    predictDesc:
      'Get a clear view of your future receivables. The system projects your revenue based on active subscribers and rotary customer history, facilitating your financial planning.',
    methodsTitle: 'Multiple Methods',
    methodsDesc:
      'Offer convenience to customers by registering payments quickly and securely through various integrated methods:',
    card: 'Card (Credit/Debit)',
    pix: 'PIX/Digital',
    cash: 'Cash',
    cashTitle: 'Complete Cash Management',
    cashDesc:
      'Bulletproof operational control. Manage openings with change funds, detailed closings by operator, and monitor cash flow in real-time to avoid losses and operational gaps.',
  },
  faq: {
    title: 'Plans and Pricing',
    subtitle:
      'Choose the ideal plan for the size of your operation. No hidden fees, no surprises at the end of the month.',
    popular: 'Most Popular',
    proTitle: 'Professional',
    proDesc: 'Ideal for growing parking lots',
    month: '/month',
    proF1: 'Subscriber Management (Full module)',
    proF2: 'Smart Check-in and Check-out',
    proF3: 'KPIs Dashboard and Financial Intelligence',
    proF4: 'Real-time Space Map',
    proF5: 'Vehicle and customer registration',
    getStarted: 'Get Started',
    entTitle: 'Enterprise',
    entDesc: 'For large scale operations and complex requirements',
    custom: 'Custom',
    entF1: 'Everything in the Professional plan',
    entF2: 'Physical ticket printing',
    entF3: '24/7 priority support',
    entF4: 'Integration with automation hardware',
    entF5: 'Multi-unit management (multiple parking lots)',
    talkToUs: 'Talk to Sales',
    faqTitle: 'Frequently Asked Questions',
    q1: 'Does it work on mobile?',
    a1: 'Yes! The system was designed to be "Mobile First", working perfectly on any smartphone or tablet, ideal for attendants in the yard.',
    q2: 'Do I need special equipment?',
    a2: 'No. Just a device with internet access (phone, tablet, or computer). No complex installation is necessary.',
    q3: 'Can I configure my own prices?',
    a3: 'Absolutely. You can create custom rules for initial value, additional hour, daily cap, and tolerance for different types of vehicles.',
    q4: 'Can I have more than one parking lot?',
    a4: 'The plan covers one unit. For multiple units, contact us for a discounted corporate plan.',
    q5: 'How does data security work?',
    a5: 'Your data is saved in the cloud on ultra-secure servers. You will not lose any information even if your computer or phone breaks.',
  },
  footer: {
    title: 'Take control of your parking lot.',
    subtitle:
      'Stop losing money with manual controls. The modernization your business needs is one click away.',
    demo: 'Request Demo',
    rights: 'All rights reserved.',
  },
  demo: {
    title: 'Request a Demo',
    desc: 'Fill in your details below and discover how Parkko can transform your parking management.',
    name: 'Full Name',
    company: 'Company',
    email: 'Corporate Email',
    phone: 'Phone / WhatsApp',
    spots: 'Number of Spaces',
    submit: 'Send Request',
    successTitle: 'Request sent!',
    successDesc: 'Our team will contact you shortly for the demonstration.',
  },
}

const es = {
  nav: {
    dashboard: 'Dashboard',
    operation: 'Operación',
    subscribers: 'Abonados',
    plans: 'Planes',
    login: 'Iniciar Sesión',
    getStarted: 'Empezar',
  },
  hero: {
    title1: 'Gestión',
    titleHighlight: 'Inteligente',
    title2: 'de Estacionamientos',
    subtitle:
      'Controla el patio, la facturación, los abonados y las reglas de precios en tiempo real. Una plataforma moderna diseñada para una alta conversión y un uso rápido.',
    getStarted: 'Empezar Ahora',
    accessSystem: 'Acceder al Sistema',
    vehiclesInYard: 'Vehículos en Patio',
    occupancy: 'de Ocupación',
    revenueToday: 'Ingresos de Hoy',
    transactions: 'transacciones',
    avgTicket: 'Ticket Promedio',
    perVehicle: 'Por vehículo finalizado',
    cashStatus: 'Estado de Caja',
    open: 'Abierto',
    startedAt: 'inició hace 4h 30m',
  },
  yard: {
    badge: 'Mapeo Interactivo',
    title: 'Mapa de Espacios en Tiempo Real',
    subtitle:
      'Visualiza rápidamente la ocupación de tu patio. Identifica espacios libres, ocupados, reservados o en mantenimiento con un solo vistazo.',
    free: 'Espacios libres listos para usar',
    occupied: 'Espacios ocupados con la placa del vehículo',
    reserved: 'Espacios reservados para clientes especiales',
    maintenance: 'Espacios en mantenimiento bloqueados temporalmente',
  },
  op: {
    title: 'Check-out Ultra Rápido',
    subtitle:
      'El proceso de salida fue optimizado para que tu operador no pierda tiempo. Todo en la misma pantalla, con cajones deslizantes y atajos prácticos.',
    checkout: 'Finalizar Salida',
    entryAt: 'Entrada a las 08:30',
    duration: 'Permanencia',
    amount: 'Valor a cobrar',
    cash: 'Efectivo',
    pix: 'Pix/Transferencia',
    confirm: 'Confirmar y Finalizar',
  },
  sub: {
    badge: 'Ingresos Recurrentes',
    title: 'Gestión de Abonados',
    subtitle:
      'Fideliza a tus clientes con planes mensuales y controla la morosidad. El sistema reconoce automáticamente los vehículos registrados.',
    active: '🟢 Abonado Activo',
    plates: 'Placas Registradas',
    dueDate: 'Vencimiento',
    monthlyFee: 'Mensualidad',
    dueDay: 'Día 05',
    recognitionTitle: 'Reconocimiento Automático',
    recognitionDesc:
      'Al escribir la placa, el sistema avisa si es un abonado y exime el cobro único.',
    multiplePlatesTitle: 'Múltiples Placas',
    multiplePlatesDesc:
      'Registra varios vehículos para el mismo abonado (uso alterno).',
    defaultControlTitle: 'Control de Morosidad',
    defaultControlDesc:
      'Alertas visuales para mensualidades atrasadas en el check-in e historial de pagos.',
  },
  price: {
    title: 'Motor de Precios Flexible',
    subtitle:
      'Cualquiera que sea la regla de tu estacionamiento, Parkko la calcula por ti automáticamente. Sin errores y sin calculadora.',
    f1Title: 'Tarifas Diferenciadas por Vehículo',
    f1Desc:
      'Diferentes precios para autos, motos, camionetas o camiones. Configura cada uno con flexibilidad.',
    f2Title: 'Horas Pico',
    f2Desc:
      'Aumenta el precio automáticamente en horas de mayor movimiento con un multiplicador configurable.',
    f3Title: 'Precio Progresivo',
    f3Desc:
      'Configura el valor de la primera hora y fracciones/horas adicionales de forma exacta o redondeada.',
    f4Title: 'Límite Diario y Tolerancia',
    f4Desc:
      'Establece un monto máximo a cobrar por día y define los minutos de exención.',
  },
  fin: {
    title: 'Inteligencia Financiera',
    subtitle:
      'Toma decisiones basadas en datos reales. Sigue la evolución de tus ingresos y compara la estabilidad de los abonados con los picos de ingresos rotativos.',
    f1: 'Gráficos fáciles de leer por período',
    f2: 'Exportación a CSV (Compatible con Contabilidad)',
    f3: 'Cierre de caja detallado y blindado',
    chartTitle: 'Composición de Ingresos',
    chartDesc: 'Rotativo vs Abonados (Últimos 7 días)',
    rotary: 'Rotativo',
    monthly: 'Abonado',
    mon: 'Lun',
    tue: 'Mar',
    wed: 'Mié',
    thu: 'Jue',
    fri: 'Vie',
    sat: 'Sáb',
    sun: 'Dom',
  },
  pay: {
    title: 'Gestión de Pagos Inteligente',
    subtitle:
      'Mantén la salud financiera de tu estacionamiento bajo control. Ten una visibilidad clara de tus ingresos y ofrece flexibilidad al cobrar.',
    predictTitle: 'Previsibilidad de Pagos',
    predictDesc:
      'Ten una visión clara de tus cuentas por cobrar futuras. El sistema proyecta tus ingresos en base a abonados activos e historial de clientes rotativos, facilitando tu planificación financiera.',
    methodsTitle: 'Múltiples Métodos',
    methodsDesc:
      'Ofrece comodidad a los clientes registrando pagos de forma rápida y segura a través de diversos métodos integrados:',
    card: 'Tarjeta (Crédito/Débito)',
    pix: 'PIX/Digital',
    cash: 'Efectivo',
    cashTitle: 'Gestión de Caja Completa',
    cashDesc:
      'Control operativo blindado. Gestiona aperturas con fondos de cambio, cierres detallados por operador y monitorea el flujo de caja en tiempo real para evitar pérdidas y brechas operativas.',
  },
  faq: {
    title: 'Planes y Precios',
    subtitle:
      'Elige el plan ideal para el tamaño de tu operación. Sin tarifas ocultas, sin sorpresas a fin de mes.',
    popular: 'Más Popular',
    proTitle: 'Profesional',
    proDesc: 'Ideal para estacionamientos en crecimiento',
    month: '/mes',
    proF1: 'Gestión de Abonados (Módulo completo)',
    proF2: 'Check-in y Check-out inteligente',
    proF3: 'Panel de KPIs e Inteligencia Financiera',
    proF4: 'Mapa de Espacios en tiempo real',
    proF5: 'Registro de vehículos y clientes',
    getStarted: 'Empezar Ahora',
    entTitle: 'Enterprise',
    entDesc: 'Para operaciones a gran escala y requisitos complejos',
    custom: 'Bajo Consulta',
    entF1: 'Todo en el plan Profesional',
    entF2: 'Impresión de tickets física',
    entF3: 'Soporte prioritario 24/7',
    entF4: 'Integración con hardware de automatización',
    entF5: 'Gestión multi-unidades (varios estacionamientos)',
    talkToUs: 'Hablar con Ventas',
    faqTitle: 'Preguntas Frecuentes',
    q1: '¿Funciona en el móvil?',
    a1: '¡Sí! El sistema fue diseñado para ser "Mobile First", funcionando perfectamente en cualquier teléfono o tablet, ideal para los asistentes en el patio.',
    q2: '¿Necesito equipo especial?',
    a2: 'No. Solo un dispositivo con acceso a internet (teléfono, tablet o computadora). No es necesaria ninguna instalación compleja.',
    q3: '¿Puedo configurar mis propios precios?',
    a3: 'Absolutamente. Puedes crear reglas personalizadas de valor inicial, hora adicional, límite diario y tolerancia para diferentes tipos de vehículos.',
    q4: '¿Puedo tener más de un estacionamiento?',
    a4: 'El plan cubre una unidad. Para múltiples unidades, contáctanos para un plan corporativo con descuento.',
    q5: '¿Cómo funciona la seguridad de los datos?',
    a5: 'Tus datos se guardan en la nube en servidores ultra seguros. No perderás ninguna información incluso si tu computadora o teléfono se rompen.',
  },
  footer: {
    title: 'Toma el control de tu estacionamiento.',
    subtitle:
      'Deja de perder dinero con controles manuales. La modernización que tu negocio necesita está a un clic de distancia.',
    demo: 'Solicitar Demostración',
    rights: 'Todos los derechos reservados.',
  },
  demo: {
    title: 'Solicitar una Demostración',
    desc: 'Completa tus datos a continuación y descubre cómo Parkko puede transformar la gestión de tu estacionamiento.',
    name: 'Nombre Completo',
    company: 'Empresa',
    email: 'Correo Corporativo',
    phone: 'Teléfono / WhatsApp',
    spots: 'Número de Espacios',
    submit: 'Enviar Solicitud',
    successTitle: '¡Solicitud enviada!',
    successDesc:
      'Nuestro equipo se pondrá en contacto en breve para la demostración.',
  },
}

const fr = {
  nav: {
    dashboard: 'Tableau de Bord',
    operation: 'Opération',
    subscribers: 'Abonnés',
    plans: 'Forfaits',
    login: 'Connexion',
    getStarted: 'Commencer',
  },
  hero: {
    title1: 'Gestion',
    titleHighlight: 'Intelligente',
    title2: 'de Parking',
    subtitle:
      'Contrôlez la cour, la facturation, les abonnés et les règles de tarification en temps réel. Une plateforme moderne conçue pour une conversion élevée et une utilisation rapide.',
    getStarted: 'Commencer',
    accessSystem: 'Accéder au Système',
    vehiclesInYard: 'Véhicules dans la Cour',
    occupancy: "d'Occupation",
    revenueToday: 'Revenus du Jour',
    transactions: 'transactions simples',
    avgTicket: 'Ticket Moyen',
    perVehicle: 'Par véhicule terminé',
    cashStatus: 'Statut de Caisse',
    open: 'Ouvert',
    startedAt: 'démarré il y a 4h 30m',
  },
  yard: {
    badge: 'Cartographie Interactive',
    title: 'Carte des Places en Temps Réel',
    subtitle:
      "Visualisez rapidement l'occupation de votre cour. Identifiez les places libres, occupées, réservées ou en maintenance en un coup d'œil.",
    free: "Places libres prêtes à l'emploi",
    occupied: 'Places occupées avec plaque de véhicule',
    reserved: 'Places réservées pour clients spéciaux',
    maintenance: 'Places en maintenance temporairement bloquées',
  },
  op: {
    title: 'Départ Ultra Rapide',
    subtitle:
      'Le processus de départ a été optimisé pour que votre opérateur ne perde pas de temps. Tout sur le même écran, avec des tiroirs coulissants et des raccourcis pratiques.',
    checkout: 'Finaliser le Départ',
    entryAt: 'Entrée à 08:30',
    duration: 'Durée',
    amount: 'Montant à facturer',
    cash: 'Espèces',
    pix: 'Pix/Virement',
    confirm: 'Confirmer et Terminer',
  },
  sub: {
    badge: 'Revenus Récurrents',
    title: 'Gestion des Abonnés',
    subtitle:
      'Fidélisez vos clients avec des forfaits mensuels et contrôlez les impayés. Le système reconnaît automatiquement les véhicules enregistrés.',
    active: '🟢 Abonné Actif',
    plates: 'Plaques Enregistrées',
    dueDate: "Date d'Échéance",
    monthlyFee: 'Frais Mensuels',
    dueDay: 'Jour 05',
    recognitionTitle: 'Reconnaissance Automatique',
    recognitionDesc:
      "En tapant la plaque, le système avertit si c'est un abonné et exempte la charge unique.",
    multiplePlatesTitle: 'Plusieurs Plaques',
    multiplePlatesDesc:
      'Enregistrez plusieurs véhicules pour le même abonné (utilisation alternée).',
    defaultControlTitle: 'Contrôle des Impayés',
    defaultControlDesc:
      "Alertes visuelles pour les frais mensuels en retard à l'arrivée et historique des paiements.",
  },
  price: {
    title: 'Moteur de Prix Flexible',
    subtitle:
      'Quelle que soit la règle de votre parking, Parkko la calcule pour vous automatiquement. Sans erreurs et sans calculatrice.',
    f1Title: 'Tarifs Différenciés par Véhicule',
    f1Desc:
      'Des prix différents pour les voitures, motos, fourgonnettes ou camions. Configurez chacun de manière flexible.',
    f2Title: 'Heures de Pointe',
    f2Desc:
      'Augmentez automatiquement le prix pendant les heures de pointe avec un multiplicateur configurable.',
    f3Title: 'Prix Progressif',
    f3Desc:
      'Définissez la valeur de la première heure et des fractions/heures supplémentaires exactement ou arrondies.',
    f4Title: 'Plafond Quotidien et Tolérance',
    f4Desc:
      "Établissez un montant maximum à facturer par jour et définissez les minutes d'exemption.",
  },
  fin: {
    title: 'Intelligence Financière',
    subtitle:
      "Prenez des décisions basées sur des données réelles. Suivez l'évolution de vos revenus et comparez la stabilité des abonnés avec les pics de revenus rotatifs.",
    f1: 'Graphiques faciles à lire par période',
    f2: 'Exportation vers CSV (Compatible Comptabilité)',
    f3: 'Fermeture de caisse détaillée et blindée',
    chartTitle: 'Composition des Revenus',
    chartDesc: 'Rotatif vs Abonnés (7 derniers jours)',
    rotary: 'Rotatif',
    monthly: 'Abonné',
    mon: 'Lun',
    tue: 'Mar',
    wed: 'Mer',
    thu: 'Jeu',
    fri: 'Ven',
    sat: 'Sam',
    sun: 'Dim',
  },
  pay: {
    title: 'Gestion Intelligente des Paiements',
    subtitle:
      'Gardez la santé financière de votre parking sous contrôle. Ayez une visibilité claire de vos revenus et offrez de la flexibilité lors de la facturation.',
    predictTitle: 'Prévisibilité des Paiements',
    predictDesc:
      "Ayez une vision claire de vos futures créances. Le système projette vos revenus en fonction des abonnés actifs et de l'historique des clients rotatifs, facilitant votre planification financière.",
    methodsTitle: 'Méthodes Multiples',
    methodsDesc:
      'Offrez de la commodité aux clients en enregistrant les paiements rapidement et en toute sécurité grâce à diverses méthodes intégrées:',
    card: 'Carte (Crédit/Débit)',
    pix: 'PIX/Digital',
    cash: 'Espèces',
    cashTitle: 'Gestion Complète de la Caisse',
    cashDesc:
      'Contrôle opérationnel blindé. Gérez les ouvertures avec des fonds de caisse, les fermetures détaillées par opérateur, et surveillez les flux de trésorerie en temps réel pour éviter les pertes et les lacunes opérationnelles.',
  },
  faq: {
    title: 'Forfaits et Prix',
    subtitle:
      'Choisissez le forfait idéal pour la taille de votre opération. Pas de frais cachés, pas de surprises à la fin du mois.',
    popular: 'Le Plus Populaire',
    proTitle: 'Professionnel',
    proDesc: 'Idéal pour les parkings en croissance',
    month: '/mois',
    proF1: 'Gestion des Abonnés (Module complet)',
    proF2: 'Arrivée et Départ intelligents',
    proF3: 'Tableau de bord KPIs et Intelligence Financière',
    proF4: 'Carte des Places en temps réel',
    proF5: 'Enregistrement des véhicules et des clients',
    getStarted: 'Commencer',
    entTitle: 'Enterprise',
    entDesc: 'Pour les opérations à grande échelle et les exigences complexes',
    custom: 'Sur Mesure',
    entF1: 'Tout dans le forfait Professionnel',
    entF2: 'Impression de tickets physiques',
    entF3: 'Support prioritaire 24/7',
    entF4: "Intégration avec le matériel d'automatisation",
    entF5: 'Gestion multi-unités (plusieurs parkings)',
    talkToUs: 'Parler aux Ventes',
    faqTitle: 'Questions Fréquentes',
    q1: 'Est-ce que ça marche sur mobile?',
    a1: 'Oui ! Le système a été conçu pour être "Mobile First", fonctionnant parfaitement sur tout smartphone ou tablette, idéal pour les préposés dans la cour.',
    q2: "Ai-je besoin d'un équipement spécial?",
    a2: "Non. Juste un appareil avec accès à internet (téléphone, tablette ou ordinateur). Aucune installation complexe n'est nécessaire.",
    q3: 'Puis-je configurer mes propres prix?',
    a3: "Absolument. Vous pouvez créer des règles personnalisées pour la valeur initiale, l'heure supplémentaire, le plafond quotidien et la tolérance pour différents types de véhicules.",
    q4: "Puis-je avoir plus d'un parking?",
    a4: "Le forfait couvre une unité. Pour plusieurs unités, contactez-nous pour un forfait d'entreprise à prix réduit.",
    q5: 'Comment fonctionne la sécurité des données?',
    a5: 'Vos données sont sauvegardées dans le cloud sur des serveurs ultra-sécurisés. Vous ne perdrez aucune information même si votre ordinateur ou votre téléphone tombe en panne.',
  },
  footer: {
    title: 'Prenez le contrôle de votre parking.',
    subtitle:
      "Arrêtez de perdre de l'argent avec des contrôles manuels. La modernisation dont votre entreprise a besoin est à un clic.",
    demo: 'Demander une Démo',
    rights: 'Tous droits réservés.',
  },
  demo: {
    title: 'Demander une Démo',
    desc: 'Remplissez vos coordonnées ci-dessous et découvrez comment Parkko peut transformer la gestion de votre parking.',
    name: 'Nom Complet',
    company: 'Entreprise',
    email: 'Email Professionnel',
    phone: 'Téléphone / WhatsApp',
    spots: 'Nombre de Places',
    submit: 'Envoyer la Demande',
    successTitle: 'Demande envoyée !',
    successDesc: 'Notre équipe vous contactera sous peu pour la démonstration.',
  },
}

export const translations = { pt, en, es, fr }
